/**
 * @package  	grahamengineering
 * @copyright	Copyright (c) 2021 Synapse Marketing Solutions (http://www.synapseresults.com)
 * @version  	1.0.0
 *
 * @Resources	https://git.synapseresults.com/interactive/synpulse-resources
 */
if (typeof $ === "undefined") {
  var $ = jQuery;
}

/
 * Contact Form 7
 *
 * JQuery Masked Input Documentation
 * assets/js/vendor/maskedinput/
 *
 * Custom Select Option Documentation
 * assets/js/vendor/tail.select/
 /
// CF7 On Submit

  document.addEventListener("wpcf7mailsent", function (event) {
    // var siteURL = window.location.protocol + "//" + window.location.hostname;
    if ("4" == event.detail.contactFormId) {
      $(".module__item--form-container-header").hide();
      $(".contact__form--container").hide();
      $(".contact__form--response").show();

      // Form redirect for the CF7 form with the 817 ID
      // location = siteURL + "/thank-you-quote/";
    } else if ("639" == event.detail.contactFormId) {
      $(".module__item--form-container-header").hide();
      $(".contact__form--container").hide();
      $(".contact__form--response").show();
    } else if ("640" == event.detail.contactFormId) {
      $(".module__item--form-container-header").hide();
      $(".contact__form--container").hide();
      $(".contact__form--response").show();
    } else if ("749" == event.detail.contactFormId) {
      $(".module__item--form-container-header").hide();
      $(".contact__form--container").hide();
      $(".contact__form--response").show();
    } else if ("3312" == event.detail.contactFormId) {
      $(".contact_hide_on_submit").hide();
      $(".module__item--form-container-header").hide();
      $(".contact__form--container").hide();
      $(".contact__form--response").show();
    } else if ("3423" == event.detail.contactFormId) {
      $(".contact_hide_on_submit").hide();
      $(".module__item--form-container-header").hide();
      $(".contact__form--container").hide();
      $("#free-consultation-response").show();
    } else if ("4184" == event.detail.contactFormId || "4179" == event.detail.contactFormId) { // Total Cost of Ownership Landing Page form Dev/Live IDs
      $(".contact_hide_on_submit").hide();
      $(".module__item--form-container-header").hide();
      $(".contact__form--container").hide();
      $("#free-consultation-response").show();
    } else if ("3344" == event.detail.contactFormId) {
      $(".contact_hide_on_submit").hide();
      $(".module__item--form-container-header").hide();
      $(".contact__form--container").hide();
      $("#free-consultation-response").show();
    } else if ("3447" == event.detail.contactFormId) {
      $(".contact_hide_on_submit").hide();
      $(".module__item--form-container-header").hide();
      $(".contact__form--container").hide();
      $("#free-consultation-response").show();
    } else if (event.detail.contactFormId === 4287) {
      $(".contact_hide_on_submit").hide();
      $(".module__item--form-container-header").hide();
      $(".contact__form--container").hide();
      $("#free-consultation-response").show();
    } else if (event.detail.contactFormId === 4318) {
      $(".contact_hide_on_submit").hide();
      $(".module__item--form-container-header").hide();
      $(".contact__form--container").hide();
      $("#free-consultation-response").show();
    } else if (event.detail.contactFormId === 4325) {
      $(".contact_hide_on_submit").hide();
      $(".module__item--form-container-header").hide();
      $(".contact__form--container").hide();
      $("#free-consultation-response").show();
    }
  }, false);

/
 * Functions on Doc Ready
 /
$(document).ready(function () {
  /**
   * Slick Functionality that needs to fire before slick runs
   */
  $("[data-gallery-slick]").on("init", function (event, slick, direction) {
    if (!($("[data-gallery-slick] .slick-slide").length > 1)) {
      $(".slick-dots").hide();
    }
  });

  const videoPlayers = {};

  function pauseVimeoVideo(selector) {
    const $el = $(selector);
    const id = $el.data("id");

    if (videoPlayers[id]) {
      videoPlayers[id].pause();
    }
  }

  function playVimeoVideo(selector, shouldLoop) {
    const $el = $(selector);
    const $slick = $el.parents("[data-gallery-slick]");

    const url = $el.data("url") || "";
    const isVimeo = url.includes("vimeo.com");

    if (!isVimeo) {
      throw new Error("need to be vimeo link");
    }

    let id;
    if ($el.data("id")) {
      id = $el.data("id");
    } else {
      id = url.replace(/[^a-zA-Z0-9]/g, "") + Math.floor(Math.random() * 100);

      $el.data("id", id);
    }

    function onPlay() {
      const $iframe = $el.find("iframe");

      $slick.slick("slickPause");

      $el
        .parents(".module__item")
        .find(".video-background")
        .toggleClass("active", true);

      $iframe.toggleClass("active", true);

      $el.show();
    }

    let videoPlayer = videoPlayers[id];

    if (!videoPlayer) {
      const options = {
        url,
        // width: 800,
        badge: 0,
        autopause: 0,
        player_id: 0,
        autoplay: 1,
        controls: 0,
        muted: 1,
        title: 0,
        keyboard: 0,
        showinfo: 0,
        loop: shouldLoop ? 1 : 0,
      };

      let videoReady = false;

      $el.hide();

      videoPlayer = videoPlayers[id] = new Vimeo.Player($el[0], options);

      videoPlayer.ready().then(() => {
        const $iframe = $el.find("iframe");

        $iframe.toggleClass("module__item--iframe", true);

        videoPlayer.play();
      });

      videoPlayer.on("bufferend", () => {
        if (!videoReady) {
          videoReady = true;
          onPlay();

          videoPlayer.on("play", onPlay);
        }
      });

      videoPlayer.on("ended", function () {
        $slick.slick("slickPlay");
        $slick.slick("next");
      });
    } else {
      $el.hide();

      $el
        .parents(".module__item")
        .find(".video-background")
        .toggleClass("active", false);

      videoPlayer.play();
      // videoPlayer.setLoop(true).then(() => {
      // });
    }

    $slick.slick("slickPause");
  }

  function handleButtonClicked(e) {
    var iframe = $(this).parents(".module__item").find(".module__item--iframe");

    $(this)
      .parents(".module__item")
      .find(".video-background")
      .addClass("active");
    iframe.addClass("active");
    iframe.attr("allow", "autoplay; fullscreen; picture-in-picture");
    iframe.attr("allowfullscreen", "true");
    iframe.attr(
      "src",
      iframe.attr("src") +
        "?badge=0&amp;autopause=0&amp;player_id=0&amp;autoplay=1&amp;controls=0&amp;muted=1&amp;title=0&amp;loop=1&amp;keyboard=0&amp;showinfo=0"
    );

    if ($(this).parents("[data-gallery-slick]")) {
      $(this).parents("[data-gallery-slick]").slick("slickPause");
    }
  }

  $(document).on(
    "afterChange",
    "[data-gallery-slick]",
    function (e, slick, currentSlide) {
      const $slide = $(slick.$slides[currentSlide]);
      const $playerLoader = $slide.find(".vimeo-video-player-loader");

      if ($playerLoader.length) {
        playVimeoVideo($playerLoader);
      }
    }
  );

  $(document).on(
    "beforeChange",
    "[data-gallery-slick]",
    function (e, slick, currentSlide) {
      const $slide = $(slick.$slides[currentSlide]);
      const $playerLoader = $slide.find(".vimeo-video-player-loader");

      if ($playerLoader.length) {
        pauseVimeoVideo($playerLoader);
      }
    }
  );

  const $playerLoader = $(".module__item--image").find(
    ".vimeo-video-player-loader"
  );
  if ($playerLoader.length) {
    playVimeoVideo($playerLoader, true);
  }

  $(document).on("click", ".btn--video", function (e) {
    const $this = $(this);
    const $parent = $this.parents(".module__item");
    const $playerLoader = $parent.find(".vimeo-video-player-loader");

    if ($playerLoader.length) {
      playVimeoVideo($playerLoader);
    } else {
      handleButtonClicked.call(this, e);
    }

    return false;
  });

  $(document).on("click", "form.wpcf7-form .btn--next-step", function (e) {
    var totalPages = $("form.wpcf7-form [data-page]").length;
    var currentPage = parseInt($(this).parent("[data-page]").attr("data-page"));
    var nextPage = parseInt(currentPage) + 1;

    if (nextPage < totalPages) {
      $(".is-active[data-page]").removeClass("is-active");
      $('[data-page="' + nextPage + '"]').addClass("is-active");
    }
  });
  // END extra slick functionality

  $("[data-gallery-slick]").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 9000,
    fade: true,
    cssEase: "ease",
  });

  $(".module__content-history--history").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 1000,
    dots: false,
    arrows: true,
    autoplay: false,
    fade: false,
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 851,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 501,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".module__item-careers-list").slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 1000,
    dots: false,
    arrows: true,
    autoplay: false,
    fade: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
    ],
  });

  $(".module__item--articles").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 1000,
    dots: false,
    arrows: true,
    autoplay: false,
    fade: false,
    centerMode: false,
    mobileFirst: false,
    responsive: [
      {
        breakpoint: 1471,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $("[data-testimonials]").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
    dots: true,
    arrows: false,
    fade: true,
    autoplay: true,
    autoplaySpeed: 6000,
    fade: true,
    cssEase: "ease",
    adaptiveHeight: true,
  });

  // Request A Quote form page logic
  if ($("body.request-a-quote").length > 0) {
    var request_quote_step_2;
    $('input[name="product_select"]').change(function (e) {
      if ($(this).val() == "Blow Molding/Wheel") {
        request_quote_step_2 = 1;
      } else if ($(this).val() == "Blow Molding/Accumulator Head") {
        request_quote_step_2 = 2;
      } else if ($(this).val() == "Extruders and Extrusion Systems") {
        request_quote_step_2 = 3;
      } else if ($(this).val() == "Sheet Extrusion") {
        request_quote_step_2 = 4;
      } else if ($(this).val() == "Parts/Services") {
        request_quote_step_2 = 5;
      } else if ($(this).val() == "I'm not sure") {
        request_quote_step_2 = 6;
      }
    });

    $("#cf7mls-next-btn-cf7mls_step-1").on("click", function (e) {
      if (request_quote_step_2 !== undefined) {
        $('.fieldset-cf7mls[data-cf7mls-order="0"]').removeClass(
          "cf7mls_current_fs"
        );
        switch (request_quote_step_2) {
          case 1:
            $('.fieldset-cf7mls[data-cf7mls-order="1"]').addClass(
              "cf7mls_current_fs"
            );
            break;
          case 2:
            $('.fieldset-cf7mls[data-cf7mls-order="2"]').addClass(
              "cf7mls_current_fs"
            );
            break;
          case 3:
            $('.fieldset-cf7mls[data-cf7mls-order="3"]').addClass(
              "cf7mls_current_fs"
            );
            break;
          case 4:
            $('.fieldset-cf7mls[data-cf7mls-order="4"]').addClass(
              "cf7mls_current_fs"
            );
            break;
          case 5:
            $('.fieldset-cf7mls[data-cf7mls-order="5"]').addClass(
              "cf7mls_current_fs"
            );
            break;
          case 6:
            $('.fieldset-cf7mls[data-cf7mls-order="6"]').addClass(
              "cf7mls_current_fs"
            );
            break;
        }
      }
      e.preventDefault();
      return false;
    });

    $(
      "#cf7mls-next-btn-cf7mls_step-2, #cf7mls-next-btn-cf7mls_step-3, #cf7mls-next-btn-cf7mls_step-4, #cf7mls-next-btn-cf7mls_step-5, #cf7mls-next-btn-cf7mls_step-6"
    ).on("click", function (e) {
      $('.fieldset-cf7mls[data-cf7mls-order="0"]').removeClass(
        "cf7mls_current_fs"
      );
      $('.fieldset-cf7mls[data-cf7mls-order="1"]').removeClass(
        "cf7mls_current_fs"
      );
      $('.fieldset-cf7mls[data-cf7mls-order="2"]').removeClass(
        "cf7mls_current_fs"
      );
      $('.fieldset-cf7mls[data-cf7mls-order="3"]').removeClass(
        "cf7mls_current_fs"
      );
      $('.fieldset-cf7mls[data-cf7mls-order="4"]').removeClass(
        "cf7mls_current_fs"
      );
      $('.fieldset-cf7mls[data-cf7mls-order="5"]').removeClass(
        "cf7mls_current_fs"
      );
      $('.fieldset-cf7mls[data-cf7mls-order="6"]').removeClass(
        "cf7mls_current_fs"
      );
      $('.fieldset-cf7mls[data-cf7mls-order="7"]').addClass(
        "cf7mls_current_fs"
      );
      e.preventDefault();
      return false;
    });
  }
  // end request form logic
});

$(document).mobileNav();

/
 * Functions window resize
 /
$(window)
  .resize(function () {})
  .resize();

/
 * Functions window loaded
 /
window.addEventListener("load", function () {
  function hidePreloader() {
    var preloader = $(".spinner-outer-container");
    preloader.fadeOut(200);
  }

  hidePreloader();
});

// Custom Select option
/*
document.addEventListener("DOMContentLoaded", function(){
	tail.select(".wpcf7-select,.form-select-box", {
		width: '100%',
		placeholder: '',
		multiple: false,
		search: false
	});
});
*/

// START Equal Height
function setCtaPostEqualHeight() {
  var $containers = $('.module__featured-posts.module__featured-posts--transparent-background');

  $containers.each(function (index, container) {
    var $toChangeElement = $(container).find('.module__item.cta-post');
    var $toMatchElement = $(container).find('.featured-posts');
    var toChangeHeight = $toMatchElement[0].clientHeight;

    $toChangeElement.css('height', ( toChangeHeight - 2 ) + 'px');
  });
}

function getEqualHeights(items, element) {
  var $items = $(items);
  var tallest = {};
  var currentIndex = 0;

  $items.each((index, iel) => {
    if (index % 3 === 0) {
      currentIndex = index;
      tallest[currentIndex] = 0;
    }
    
    var $iel = $(iel);
    var ielHeight = $iel.find(element)[0].clientHeight;

    if (ielHeight > tallest[currentIndex]) tallest[currentIndex] = ielHeight;
  });

  return new Promise((resolve) => {
      resolve(tallest);
  });
}

async function equalHeight(items, element) {
  var $items = $(items);
  var tallest = {};
  var currentIndex = 0

  if ( window.innerWidth > 1024) {
    // Get the tallest height
    tallest = await getEqualHeights(items, element);

    // Set the height of all items to the tallest
    $items.each((index, iel) => {
      if (index % 3 === 0) {
        currentIndex = index;
      }

      var $iel = $(iel);
      $iel.find(element).css('height', tallest[currentIndex] + 'px');
    });
  }
}

equalHeight('.module__news-events-list .module__item', '.module__item-block-content');
setCtaPostEqualHeight();

jQuery(document).on('loadMorePosts:added', () => {
  setTimeout(() => {
    equalHeight('.module__news-events-list .module__item', '.module__item-block-content');
    setCtaPostEqualHeight();
  }, 500)
})
// END Equal Height



// START Custom search functionality used on new GEConnect posts page - 20240208 - TD
window.syn_search_results = {
  has_set_onetime_listener: false 
}

function queryBlogPosts($s) {
  return fetch(`${window.location.origin}/wp-json/syn/v1/search?s=${$s}`)
}

function handleSearchFormSubmit(e) {
  e.preventDefault()
  
  handleSearchFormOpen();

  const $s = $(this).find('input[type="search"]').val()
  queryBlogPosts($s)
    .then(response => response.json())
    .then(data => {
      const $results = $('#search-results')
      $results.empty()
        if (data.length) {
        data.forEach(post => {
          $results.append(`
            <div class="search-result">
              <a href="${post.url}">${post.title}</a>
            </div>
          `)
        })
      } else {
        $results.append('<p>No results found</p>')
      }
    })
    .catch(error => {
      console.error('Error:', error)
    })
}

function handleSearchInputChange(e) {
  const $s = $(this).val()
  
  if ($s.length > 3) {
    handleSearchFormOpen();

    queryBlogPosts($s)
      .then(response => response.json())
      .then(data => {
        const $results = $('#search-results')
        $results.empty()
        if (data.length) {
          data.forEach(post => {
            $results.append(`
              <div class="search-result">
                <a href="${post.url}">${post.title}</a>
              </div>
            `)
          })
        } else {
          $results.append('<p>No results found</p>')
        }
      })
      .catch(error => {
        console.error('Error:', error)
      })
  }
}

function handleSearchFormReset(e) {
  $('#search-results').empty()
  $('.search-form').removeClass('active')
  $('.search-form input[type="search"]').val('')
}

function handleSearchFormClose(e) {
  $('#search-results').empty()
  $('.search-form').removeClass('active')
  $('.search-form input[type="search"]').val('')
}

function handleSearchFormOpen(e) {
  $('.search-form').addClass('active')

  if ( window.syn_search_results.has_set_onetime_listener === false ) {
    window.syn_search_results.has_set_onetime_listener = true;
    document.addEventListener('click', function(event) {
      console.log('hello')
      if (!event.target.closest('.search-form')) {
        handleSearchFormClose();
      }
    });
  }
}

function appendSearchResults(element) {
  const $searchResults = $('<div id="search-results"></div>')
  $(element).append($searchResults)
}

function appendClearButton(element) {
  const $clearButton = $('<button id="clear-search-results">Clear</button>')
  $(element).append($clearButton)
  
  $clearButton.on('click', handleSearchFormReset)
}

appendSearchResults('.search-form');
appendClearButton('.search-form');

$('.search-form').on('submit', handleSearchFormSubmit);
$('.search-form input[type="search"]').on('keyup', handleSearchInputChange);
// END Custom search functionality used on new GEConnect posts page - 20240208 - TD

function fixContactFormScrollToAnchor() {
  $('#contact_form_scroll').on('click', function(e) {
    e.preventDefault();
    var $contactForm = $('.contact-content-module__contact__form');
    var contactFormOffset = $contactForm.offset().top;
    var headerHeight = 0;

    if (window.innerWidth >= 992) {
      headerHeight = 200;
    } else {
      headerHeight = 170;
    }

    $('html, body').animate({
      scrollTop: contactFormOffset - headerHeight
    }, 1000);
  });
}

fixContactFormScrollToAnchor();